import { Scene, SceneType } from 'types/Scene';
import { call } from 'redux-saga/effects';
import analytics from 'utils/analytics';

export function* analyticsUploadDone(sceneType: SceneType, result: 'success' | 'fail') {
  if (sceneType !== SceneType.EMPTY) {
    yield call([analytics, analytics.uploadDone], {
      item: sceneType,
      result
    });
  }
}

export function* analyticsContentAdded(
  sceneType: SceneType,
  size: Scene['size'],
  file: File,
  duration: number,
  sceneId: string,
  source?: 'fte' | 'premium' | 'empty'
) {
  const { width, height } = size;
  if (sceneType === SceneType.VIDEO) {
    yield call([analytics, analytics.sceneAction], {
      action: 'change',
      width,
      height,
      size: Math.ceil(file.size),
      length: Math.ceil(duration / 1000),
      format: file.type.split('/')[1],
      result_source: 'local',
      media_type: 'video',
      item_id: sceneId
    });
  } else {
    yield call([analytics, analytics.sceneAction], {
      action: 'change',
      result_source: source || 'local',
      media_type: 'image',
      item_id: sceneId
    });
  }
}
